var userAgent = require('../internals/engine-user-agent');

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-ff-version.js
// module id = 576
// module chunks = 0 1